import { render, staticRenderFns } from "./RadioOption.vue?vue&type=template&id=6d239159&scoped=true&"
import script from "./RadioOption.vue?vue&type=script&lang=ts&"
export * from "./RadioOption.vue?vue&type=script&lang=ts&"
import style0 from "./RadioOption.vue?vue&type=style&index=0&id=6d239159&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d239159",
  null
  
)

export default component.exports